import { render, staticRenderFns } from "./NoticeAndNews.vue?vue&type=template&id=62428cb3&scoped=true&"
import script from "./NoticeAndNews.vue?vue&type=script&lang=js&"
export * from "./NoticeAndNews.vue?vue&type=script&lang=js&"
import style0 from "./NoticeAndNews.vue?vue&type=style&index=0&id=62428cb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62428cb3",
  null
  
)

export default component.exports